import { render, staticRenderFns } from "./studentDocuments.vue?vue&type=template&id=64a02dce&scoped=true&"
import script from "./studentDocuments.vue?vue&type=script&lang=js&"
export * from "./studentDocuments.vue?vue&type=script&lang=js&"
import style0 from "./studentDocuments.vue?vue&type=style&index=0&id=64a02dce&lang=scss&scoped=true&"
import style1 from "./studentDocuments.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a02dce",
  null
  
)

export default component.exports